import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./NewPreviewUI.css";
import NewNavigatorRightPreviewScreen from "./NewNavigatorRightPreviewScreen";

import axios from "axios";
import { enqueueSnackbar } from "notistack";
const NewPreviewRightEditor = ({
  targetScreenWidth,
  targetScreenHeight,
  layoutItem,
}) => {
  const [portrait, setportrait] = useState(false);
  const previewData = useSelector((state) => state.preview);
  const [screenHeight, setscreenHeight] = useState(80);
  const [screenWidth, setscreenWidth] = useState(100);
  const [hideMeetingDetails, sethideMeetingDetails] = useState(false);
  const [hideResizeOptions, sethideResizeOptions] = useState(false);
  const customisations = useSelector(
    (state) => state?.customisations?.customisations
  );
  const dispatch = useDispatch();
  const [targetWidth, setTargetWidth] = useState(
    targetScreenWidth ? targetScreenWidth : 1280
  );
  const [targetHeight, setTargetHeight] = useState(
    targetScreenHeight ? targetScreenHeight : 1024
  );
  const [manualOverWrite, setManualOverWrite] = useState(false);

  useEffect(() => {
    const headers = JSON.parse(localStorage.getItem("headers"));
    const api = localStorage.getItem("api");

    if (!manualOverWrite) {
      if (
        previewData.previewObject ||
        (previewData.previewTemplateObject &&
          !previewData.previewTemplateObject.resultantImage)
      ) {
        if (layoutItem) {
          const [width, height] = layoutItem?.layoutItem?.resolution
            .split("x")
            .map(Number);
          setTargetWidth(width);
          setTargetHeight(height);
        } else {
          setTargetWidth(targetScreenWidth || 1200);
          setTargetHeight(targetScreenHeight || 750);
        }
      }
    }

    if (portrait) {
      setscreenHeight(80);
      setscreenWidth(41.25);
    } else {
      setscreenHeight(74);
      setscreenWidth(81.25);
    }
  }, [portrait, previewData, targetScreenWidth, targetScreenHeight]);

  return (
    <div className="newPreviewRightEditorContainer">
      <div className="newPreviewRightEditorTopButtons">
        <div
          className=""
          style={{ width: "15%", justifyContent: "center", display: "flex" }}
          onClick={() => {
            enqueueSnackbar(
              "Error: The Dimensions of screen can only be updated from the Elhi Landscape Manager",
              {
                preventDuplicate: true,
                autoHideDuration: 3000,
                variant: "error",
              }
            );
          }}
        >
          Mirroring {targetWidth}x{targetHeight}
        </div>
        <div
          className="newPreviewRightEditorTopRotateScreen"
          onClick={() => {
            if (!manualOverWrite) {
              enqueueSnackbar(
                "Alert! You are changing the orientation. Your screen may on have the orientation. Proceed with caution.",
                {
                  preventDuplicate: true,
                  autoHideDuration: 3000,
                  variant: "warning",
                }
              );
            }
            setManualOverWrite(true);
            setportrait(!portrait);
            const temp = targetHeight;
            setTargetHeight(targetWidth);
            setTargetWidth(temp);
          }}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <svg
            fill="#ffffff"
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="2vw"
            height="2vw"
            viewBox="0 0 431.494 431.494"
            xmlSpace="preserve"
            stroke="#ffffff"
          >
            <g id="SVGRepo_iconCarrier">
              <g>
                <g>
                  <path d="M141.634,409.029c-1.848-4.079-5.949-6.913-10.712-6.913c-6.489,0-11.75,5.262-11.75,11.749v5.877 c0,6.49,5.261,11.752,11.75,11.752h5.875c6.489,0,11.751-5.262,11.751-11.752C148.547,414.974,145.707,410.873,141.634,409.029z" />
                  <path d="M130.921,355.756c6.489,0,11.751-5.262,11.751-11.75v-13.971c0-6.492-5.262-11.75-11.751-11.75 c-6.489,0-11.75,5.258-11.75,11.75v13.971C119.171,350.494,124.433,355.756,130.921,355.756z" />
                  <path d="M130.921,271.924c4.763,0,8.864-2.834,10.712-6.916c4.073-1.84,6.914-5.941,6.914-10.709 c0-6.49-5.262-11.752-11.751-11.752h-5.875c-6.489,0-11.75,5.262-11.75,11.752v5.873 C119.171,266.663,124.433,271.924,130.921,271.924z" />
                  <path d="M208.987,242.547h-12.031c-2.949,0-5.611,1.123-7.671,2.914V11.752c0-6.49-5.262-11.752-11.751-11.752H12.089 C5.601,0,0.339,5.262,0.339,11.752v288.482c0,6.488,5.261,11.75,11.75,11.75h165.444c6.489,0,11.751-5.262,11.751-11.75v-37.103 c2.06,1.792,4.722,2.916,7.671,2.916h12.031c6.489,0,11.751-5.262,11.751-11.75C220.738,247.809,215.476,242.547,208.987,242.547z M165.783,288.482H23.841V23.502h141.942V288.482L165.783,288.482z" />
                  <path d="M281.178,242.547h-12.031c-6.49,0-11.75,5.262-11.75,11.752c0,6.488,5.26,11.75,11.75,11.75h12.03 c6.489,0,11.751-5.262,11.751-11.75C292.929,247.809,287.667,242.547,281.178,242.547z" />
                  <path d="M353.37,242.547h-12.031c-6.49,0-11.752,5.262-11.752,11.752c0,6.488,5.262,11.75,11.752,11.75h12.031 c6.489,0,11.75-5.262,11.75-11.75C365.12,247.809,359.859,242.547,353.37,242.547z" />
                  <path d="M419.404,242.547h-5.876c-6.488,0-11.75,5.262-11.75,11.752c0,4.768,2.834,8.869,6.914,10.709 c1.842,4.082,5.942,6.916,10.712,6.916c6.489,0,11.751-5.261,11.751-11.752v-5.873 C431.155,247.809,425.893,242.547,419.404,242.547z" />
                  <path d="M419.404,318.285c-6.489,0-11.75,5.258-11.75,11.75v13.971c0,6.488,5.261,11.75,11.75,11.75s11.751-5.262,11.751-11.75 v-13.971C431.155,323.543,425.893,318.285,419.404,318.285z" />
                  <path d="M419.404,402.116c-4.77,0-8.87,2.834-10.712,6.913c-4.08,1.844-6.914,5.943-6.914,10.713 c0,6.49,5.262,11.752,11.75,11.752h5.876c6.489,0,11.751-5.262,11.751-11.752v-5.877 C431.155,407.378,425.893,402.116,419.404,402.116z" />
                  <path d="M208.987,407.992h-12.031c-6.489,0-11.75,5.262-11.75,11.75c0,6.49,5.261,11.752,11.75,11.752h12.031 c6.489,0,11.751-5.262,11.751-11.752C220.738,413.254,215.476,407.992,208.987,407.992z" />
                  <path d="M353.37,407.992h-12.031c-6.49,0-11.752,5.262-11.752,11.75c0,6.49,5.262,11.752,11.752,11.752h12.031 c6.489,0,11.75-5.262,11.75-11.752C365.12,413.254,359.859,407.992,353.37,407.992z" />
                  <path d="M281.178,407.992h-12.031c-6.49,0-11.75,5.262-11.75,11.75c0,6.49,5.26,11.752,11.75,11.752h12.03 c6.489,0,11.751-5.262,11.751-11.752C292.929,413.254,287.667,407.992,281.178,407.992z" />
                  <path d="M401.6,139.963c-4.591-4.59-12.031-4.59-16.615,0l-25.178,25.178c-2.856-58.689-49.979-105.814-108.671-108.676 l25.171-25.172c4.591-4.592,4.591-12.025,0-16.617c-4.584-4.588-12.03-4.588-16.616,0l-44.948,44.949 c-2.203,2.203-3.442,5.193-3.442,8.31c0,3.113,1.239,6.103,3.442,8.307l44.944,44.942c2.294,2.297,5.301,3.442,8.308,3.442 c3.006,0,6.019-1.146,8.308-3.442c4.592-4.588,4.592-12.025,0-16.613l-24.573-24.576c45.258,3.07,81.475,39.286,84.549,84.545 l-24.574-24.576c-4.584-4.59-12.031-4.59-16.615,0c-4.59,4.592-4.59,12.025,0,16.617l44.949,44.948 c2.202,2.204,5.191,3.442,8.308,3.442c3.117,0,6.104-1.238,8.309-3.442l44.949-44.948 C406.19,151.988,406.19,144.555,401.6,139.963z" />
                </g>
              </g>
            </g>
          </svg>
        </div>
        <div
          className="newPreviewRightEditorTopHideRotate"
          onClick={() => {
            sethideResizeOptions(!hideResizeOptions);
          }}
        >
          <div className="" style={{ marginRight: "2%" }}>
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              width="2vh"
              height="2vh"
              viewBox="0 0 50 50"
            >
              <path
                d="M0 0 C4.62 0 9.24 0 14 0 C14 4.29 14 8.58 14 13 C13.34 13 12.68 13 12 13 C11.505 9.535 11.505 9.535 11 6 C6.47266074 9.2702015 1.85762239 12.63981937 0.42822266 18.24023438 C-0.25162113 23.48926085 -0.19557765 28.71940347 0 34 C1.32 34 2.64 34 4 34 C4 34.66 4 35.32 4 36 C-4.58 36 -13.16 36 -22 36 C-22 27.42 -22 18.84 -22 10 C-21.34 10 -20.68 10 -20 10 C-20 11.32 -20 12.64 -20 14 C-8.6777349 14.81468568 -8.6777349 14.81468568 1.421875 10.70703125 C3.82579787 8.24405247 5.98591332 5.78834613 8 3 C5.36 2.67 2.72 2.34 0 2 C0 1.34 0 0.68 0 0 Z"
                fill="#ffffff"
                transform="translate(26,10)"
              />
              <path
                d="M0 0 C1.32 0 2.64 0 4 0 C4 0.66 4 1.32 4 2 C2.68 2 1.36 2 0 2 C0 1.34 0 0.68 0 0 Z"
                fill="#ffffff"
                transform="translate(38,44)"
              />
              <path
                d="M0 0 C1.32 0 2.64 0 4 0 C4 0.66 4 1.32 4 2 C2.68 2 1.36 2 0 2 C0 1.34 0 0.68 0 0 Z"
                fill="#ffffff"
                transform="translate(32,44)"
              />
              <path
                d="M0 0 C0.66 0 1.32 0 2 0 C2 1.32 2 2.64 2 4 C1.34 4 0.68 4 0 4 C0 2.68 0 1.36 0 0 Z"
                fill="#ffffff"
                transform="translate(44,42)"
              />
              <path
                d="M0 0 C0.66 0 1.32 0 2 0 C2 1.32 2 2.64 2 4 C1.34 4 0.68 4 0 4 C0 2.68 0 1.36 0 0 Z"
                fill="#ffffff"
                transform="translate(44,36)"
              />
              <path
                d="M0 0 C0.66 0 1.32 0 2 0 C2 1.32 2 2.64 2 4 C1.34 4 0.68 4 0 4 C0 2.68 0 1.36 0 0 Z"
                fill="#ffffff"
                transform="translate(44,30)"
              />
              <path
                d="M0 0 C0.66 0 1.32 0 2 0 C2 1.32 2 2.64 2 4 C1.34 4 0.68 4 0 4 C0 2.68 0 1.36 0 0 Z"
                fill="#ffffff"
                transform="translate(44,24)"
              />
              <path
                d="M0 0 C0.66 0 1.32 0 2 0 C2 1.32 2 2.64 2 4 C1.34 4 0.68 4 0 4 C0 2.68 0 1.36 0 0 Z"
                fill="#ffffff"
                transform="translate(44,18)"
              />
              <path
                d="M0 0 C0.66 0 1.32 0 2 0 C2 1.32 2 2.64 2 4 C1.34 4 0.68 4 0 4 C0 2.68 0 1.36 0 0 Z"
                fill="#ffffff"
                transform="translate(4,14)"
              />
              <path
                d="M0 0 C0.66 0 1.32 0 2 0 C2 1.32 2 2.64 2 4 C1.34 4 0.68 4 0 4 C0 2.68 0 1.36 0 0 Z"
                fill="#ffffff"
                transform="translate(44,12)"
              />
              <path
                d="M0 0 C0.66 0 1.32 0 2 0 C2 1.32 2 2.64 2 4 C1.34 4 0.68 4 0 4 C0 2.68 0 1.36 0 0 Z"
                fill="#ffffff"
                transform="translate(4,8)"
              />
              <path
                d="M0 0 C0.66 0 1.32 0 2 0 C2 1.32 2 2.64 2 4 C1.34 4 0.68 4 0 4 C0 2.68 0 1.36 0 0 Z"
                fill="#ffffff"
                transform="translate(44,6)"
              />
              <path
                d="M0 0 C1.32 0 2.64 0 4 0 C4 0.66 4 1.32 4 2 C2.68 2 1.36 2 0 2 C0 1.34 0 0.68 0 0 Z"
                fill="#ffffff"
                transform="translate(40,4)"
              />
              <path
                d="M0 0 C1.32 0 2.64 0 4 0 C4 0.66 4 1.32 4 2 C2.68 2 1.36 2 0 2 C0 1.34 0 0.68 0 0 Z"
                fill="#ffffff"
                transform="translate(34,4)"
              />
              <path
                d="M0 0 C1.32 0 2.64 0 4 0 C4 0.66 4 1.32 4 2 C2.68 2 1.36 2 0 2 C0 1.34 0 0.68 0 0 Z"
                fill="#ffffff"
                transform="translate(28,4)"
              />
              <path
                d="M0 0 C1.32 0 2.64 0 4 0 C4 0.66 4 1.32 4 2 C2.68 2 1.36 2 0 2 C0 1.34 0 0.68 0 0 Z"
                fill="#ffffff"
                transform="translate(22,4)"
              />
              <path
                d="M0 0 C1.32 0 2.64 0 4 0 C4 0.66 4 1.32 4 2 C2.68 2 1.36 2 0 2 C0 1.34 0 0.68 0 0 Z"
                fill="#ffffff"
                transform="translate(16,4)"
              />
              <path
                d="M0 0 C1.32 0 2.64 0 4 0 C4 0.66 4 1.32 4 2 C2.68 2 1.36 2 0 2 C0 1.34 0 0.68 0 0 Z"
                fill="#ffffff"
                transform="translate(10,4)"
              />
              <path
                d="M0 0 C1.32 0 2.64 0 4 0 C4 0.66 4 1.32 4 2 C2.68 2 1.36 2 0 2 C0 1.34 0 0.68 0 0 Z"
                fill="#ffffff"
                transform="translate(4,4)"
              />
            </svg>
          </div>
          <div className="newPreviewRightEditorTopHideRotateText">
            {hideResizeOptions ? (
              <span className="newPreviewRightEditorTopHideRotateText">
                Show Resize options
              </span>
            ) : (
              <span className="newPreviewRightEditorTopHideRotateText">
                Hide Resize options
              </span>
            )}
          </div>
        </div>
        {hideMeetingDetails ? (
          <div
            className="newPreviewRightEditorTopHideContent"
            onClick={() => {
              sethideMeetingDetails(!hideMeetingDetails);
            }}
          >
            Show Content
          </div>
        ) : (
          <div
            className="newPreviewRightEditorTopHideContent"
            onClick={() => {
              sethideMeetingDetails(!hideMeetingDetails);
            }}
          >
            Hide Content
          </div>
        )}
      </div>
      <div className="newPreviewRightEditorBottomScreen">
        <NewNavigatorRightPreviewScreen
          useTemplateSelected={
            previewData.previewTemplateObject != null ? true : false
          }
          targetHeight={targetHeight}
          targetWidth={targetWidth}
          hideResizeOptions={hideResizeOptions}
          hideMeetingDetails={hideMeetingDetails}
          previewData={previewData.previewObject}
          screenHeight={screenHeight}
          screenWidth={screenWidth}
        />
      </div>
    </div>
  );
};

export default NewPreviewRightEditor;
